import { DataState } from 'types/store/reducers/dataSources';

import { normalizeById } from 'store/utils';
import { Resource } from 'types';
import { ResourceActions } from 'types/store/actions/resources';
import { ResourceActionTypes } from 'types/store/actions/constants';

export const initialState: DataState<Resource> = {
  data: {},
};

export default (
  state = initialState,
  action: ResourceActions
): DataState<Resource> => {
  switch (action.type) {
    case ResourceActionTypes.RESET:
      return initialState;

    case ResourceActionTypes.LIST_ALL_SUCCESS:
    case ResourceActionTypes.LIST_SUCCESS: {
      const { records } = action.payload;
      const normalizedData = normalizeById(records);
      return {
        ...state,
        data: { ...state.data, ...normalizedData },
      };
    }
    default:
      return state;
  }
};
